import { IAuthResponse } from "src/models/Authentication/Authentication.models";

export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const LOCK = "LOCK";
export const UNLOCK = "UNLOCK";
export const REFRESH_TOKENS = "REFRESH_TOKENS";

interface LoginAction {
  type: typeof LOGIN;
  payload: IAuthResponse;
}

interface LogoutAction {
  type: typeof LOGOUT;
}

interface LockAction {
  type: typeof LOCK;
}

interface UnlockAction {
  type: typeof UNLOCK;
  payload: IAuthResponse;
}

interface RefreshTokensAction {
  type: typeof REFRESH_TOKENS;
  payload: IAuthResponse;
}

export type AuthActionTypes = LoginAction | LogoutAction | LockAction | UnlockAction | RefreshTokensAction;
